// @ts-nocheck
import { __assign, __rest } from "tslib";
import './User.css';
import React from 'react';
import { cn } from '../../utils/bem';
import { getSizeByMap } from '../../utils/getSizeByMap';
import { forwardRefWithAs } from '../../utils/types/PropsWithAsAttributes';
import { Avatar } from '../Avatar/Avatar';
import { Typography } from '../Typography';
export var userPropSize = ['xs', 's'];
export var userPropSizeDefault = userPropSize[0];
export var cnUser = cn('User');
var titleSizeMap = {
    xs: 'm',
    s: 'm',
    m: 'm'
};
var infoSizeMap = {
    xs: 's',
    s: 'm',
    m: '2xs',
    l: 'xs'
};
var avatarSizeMap = {
    s: 's',
    m: 'm',
    l: 'l'
};
export var User = forwardRefWithAs(function (props, ref) {
    var _a = props.as, as = _a === void 0 ? 'div' : _a, className = props.className, _b = props.size, size = _b === void 0 ? userPropSizeDefault : _b, avatarUrl = props.avatarUrl, name = props.name, propOnlyAvatar = props.onlyAvatar, info = props.info, contacts = props.contacts, socials = props.socials, description = props.description, flag = props.flag, country = props.country, link = props.link, otherProps = __rest(props, ["as", "className", "size", "avatarUrl", "name", "onlyAvatar", "info", "contacts", "socials", "description", "flag", "country", "link"]);
    var Tag = as;
    var onlyAvatar = propOnlyAvatar || (!name && !info);
    return (React.createElement(Tag, __assign({}, otherProps, { className: cnUser({
            size: size,
            minified: onlyAvatar,
            alignTop: !!contacts || !!socials || !!description
        }, [className]), ref: ref }),
        avatarUrl && (React.createElement("div", { className: cnUser('AvatarWrapper') },
            React.createElement(Avatar, { size: getSizeByMap(avatarSizeMap, size), url: avatarUrl, name: name }))),
        !onlyAvatar && (name || info) && (React.createElement("div", { className: cnUser('Block') },
            name && (React.createElement(Typography.Text, { className: cnUser('Name'), size: getSizeByMap(titleSizeMap, size), weight: "bold", as: link ? 'link' : 'span', to: link },
                name,
                flag && React.createElement("img", { className: cnUser('Flag'), src: (flag === null || flag === void 0 ? void 0 : flag.urlWebp) || (flag === null || flag === void 0 ? void 0 : flag.url), alt: country || (flag === null || flag === void 0 ? void 0 : flag.alt) }))),
            info && size !== 's' && (React.createElement(Typography.Text, { className: cnUser('Info'), size: getSizeByMap(infoSizeMap, size) }, info)),
            description && React.createElement("div", { className: cnUser('Description') }, description()),
            contacts && React.createElement("div", { className: cnUser('Contacts') }, contacts()),
            socials && React.createElement("div", { className: cnUser('Socials') }, socials())))));
});
